import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { AnalyticsService } from 'src/app/services/analytics/analytics.service';

@Component({
  selector: 'secondary-list-card',
  templateUrl: './secondary-list-card.component.html',
  styleUrls: ['./secondary-list-card.component.scss'],
})
export class SecondaryListCardComponent implements OnInit {
  @Input() itemInfo: any;
  @Input() isIconVisible: boolean;
  @Output() performAction = new EventEmitter<any>();

  constructor(private analyticsService: AnalyticsService) {}

  ngOnInit() {}

  async bookNow(item) {
    this.analyticsService.trackSelectedService(item);
    this.performAction.emit(item);
  }

  openAccordion() {
    this.analyticsService.trackUnified('read_more_clicked', {
      flow: 'shared',
      outcome: 'success',
      legacy_event_name: 'read_more_clicked',
      component: 'secondary-list-card-component',
    });
  }
}
